import { environment } from "src/environments/environment";

export interface AuthConfig {
  issuer: string;
  clientId: string;
  /**
   * Where a native build comes back: a registered app link the OS routes into the app.
   * Web runtimes must not use it — see `pwaRedirectUri`.
   */
  redirectUri: string;
  /**
   * Where the web deployment comes back. Kept apart from `redirectUri` because a browser
   * cannot be sent to an app link: the installed native app claims that URL, so the login
   * would finish somewhere other than the PWA it was started from.
   *
   * `LOGIN_LAUNCHER` decides between the two, and is the only place that should read
   * either field.
   */
  pwaRedirectUri: string;
  scope: string;
  expiryBufferSeconds: number;
}

export const AUTH_CONFIG: AuthConfig = environment.oidc;

/**
 * Algorithms accepted for ID token signatures — a fixed allowlist, never whatever the
 * token's own `alg` header asks for. Dispatching on that header is how `alg: none` and
 * algorithm confusion (verifying an RSA-signed token by using the public key as an HMAC
 * secret) get in.
 *
 * The IdP advertises HS256/HS384/HS512 as well. They are deliberately excluded: this is
 * a public client with no client secret, so there is no shared key that could make a
 * symmetric signature mean anything.
 */
export const ID_TOKEN_SIGNING_ALGORITHMS = [
  'RS256', 'RS384', 'RS512',
  'PS256', 'PS384', 'PS512',
  'ES256', 'ES384', 'ES512',
];

/** Leeway on `exp`/`iat`, because clocks on mobile devices drift. */
export const ID_TOKEN_CLOCK_TOLERANCE_SECONDS = 60;
